import { render } from "./linetabPage.vue?vue&type=template&id=1b25e260"
import script from "./linetabPage.vue?vue&type=script&lang=js"
export * from "./linetabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__